import { lazy, Suspense } from "react";
import LoadingFeedback from "@/components/shared/loading/LoadingFeedback";
import AgencyOutletGuard from "./AgencyOutletGuard";

const ClientsBoardPage = lazy(() => import("../pages/ClientsBoardPage"));
const NewAgencyClient = lazy(() => import("../pages/NewAgencyClient"));
const EditAgencyClient = lazy(() => import("../pages/EditAgencyClient"));

export const clientsBoardRoutes = [
  {
    path: "/clients-board",
    element: <AgencyOutletGuard />,
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<LoadingFeedback />}>
            <ClientsBoardPage />
          </Suspense>
        ),
      },
      {
        path: "new",
        element: (
          <Suspense fallback={<LoadingFeedback />}>
            <NewAgencyClient />
          </Suspense>
        ),
      },
      {
        path: ":clientId/edit",
        element: (
          <Suspense fallback={<LoadingFeedback />}>
            <EditAgencyClient />
          </Suspense>
        ),
      },
    ],
  },
];
